import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { HttpBaseService, SnackbarMsgService } from 'app/shared/services';

import { ApplicationsLoadingEnum, IApplicationForCreation } from './@shared';
import { IApplication } from '../shared';
import { environment } from 'environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ApplicationsApiService extends HttpBaseService {
  constructor() {
    super(inject(HttpClient), inject(SnackbarMsgService));
  }

  getApplications(params: any = null, loadingType: ApplicationsLoadingEnum = ApplicationsLoadingEnum.Loading) {
    const queryParams = params ? new HttpParams({fromObject: params}) : new HttpParams();

    return this._http.get<IApplication[]>(environment.apiUrl + 'apps', { 
      params: queryParams, 
      observe: "response" 
    }).pipe(
      this._handleError(false),
      this._mapPagination()
    );
  }

  getApplication(id: string, loadingType: ApplicationsLoadingEnum = ApplicationsLoadingEnum.Loading) {
    return this._http.get<IApplication>(environment.apiUrl + 'apps/' + id).pipe(
      this._handleError(),
    );
  }

  createApplication(application: IApplicationForCreation, loadingType: ApplicationsLoadingEnum = ApplicationsLoadingEnum.Creating) {
    return this._http.post<IApplication>(environment.apiUrl + 'apps', application).pipe(
      this._handleError(),
    );
  }

  updateApplication(id: string, application: IApplicationForCreation, loadingType: ApplicationsLoadingEnum = ApplicationsLoadingEnum.Updating) {
    return this._http.put<IApplication>(environment.apiUrl + 'apps/' + id, application).pipe(
      this._handleError(),
    );
  }

  deleteApplication(id: string, loadingType: ApplicationsLoadingEnum = ApplicationsLoadingEnum.Deleting) {
    return this._http.delete<void>(environment.apiUrl + 'apps/' + id).pipe(
      this._handleError(),
    );
  }
} 